module.exports = [{
      plugin: require('C:/agent/_work/1/s/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
